import {
  FETCH_SELLER_DEALROOM_ANALYTICS,
  FETCH_SELLER_DEALROOM_ANALYTICS_SUCCESS,
  FETCH_SELLER_DEALROOM_ANALYTICS_FAIL,
  FETCH_BUYER_DEALROOM_ANALYTICS,
  FETCH_BUYER_DEALROOM_ANALYTICS_SUCCESS,
  FETCH_BUYER_DEALROOM_ANALYTICS_FAIL
} from '../actions/types'

const INITIAL_STATE = {
  bySeller: {},  // sellerId -> { data, loading, error, fetchedAt }
  byBuyer: {}    // `${buyerId}:${sellerId|'all'}` -> { data, loading, error, fetchedAt }
}

const set = (map, key, patch) => ({
  ...map,
  [key]: { ...(map[key] || {}), ...patch }
})

export default function dealroomAnalyticsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SELLER_DEALROOM_ANALYTICS:
      return { ...state, bySeller: set(state.bySeller, action.payload.sellerId, { loading: true, error: null }) }
    case FETCH_SELLER_DEALROOM_ANALYTICS_SUCCESS:
      return {
        ...state,
        bySeller: set(state.bySeller, action.payload.sellerId, {
          data: action.payload.data,
          loading: false,
          error: null,
          fetchedAt: Date.now()
        })
      }
    case FETCH_SELLER_DEALROOM_ANALYTICS_FAIL:
      return { ...state, bySeller: set(state.bySeller, action.payload.sellerId, { loading: false, error: action.payload.error }) }

    case FETCH_BUYER_DEALROOM_ANALYTICS:
      return { ...state, byBuyer: set(state.byBuyer, action.payload.key, { loading: true, error: null }) }
    case FETCH_BUYER_DEALROOM_ANALYTICS_SUCCESS:
      return {
        ...state,
        byBuyer: set(state.byBuyer, action.payload.key, {
          data: action.payload.data,
          loading: false,
          error: null,
          fetchedAt: Date.now()
        })
      }
    case FETCH_BUYER_DEALROOM_ANALYTICS_FAIL:
      return { ...state, byBuyer: set(state.byBuyer, action.payload.key, { loading: false, error: action.payload.error }) }

    default:
      return state
  }
}
